import { api } from 'common';

const { FlowKeywords } = api.FlowDefinition;

export enum ScriptContextType {
  Iteration = 'Iteration',
  Repeat = 'Repeat',
}

export function getScriptContextKeywords(
  scriptContextType: ScriptContextType | undefined
): readonly string[] {
  switch (scriptContextType) {
    case ScriptContextType.Iteration:
      return [FlowKeywords.element, FlowKeywords.index];
    case ScriptContextType.Repeat:
      return [FlowKeywords.lastResult, FlowKeywords.index];
  }
  return [];
}
